export default {
  modalBackground: Styles.color.grey.five,
};
